import { wrapper, text, count } from './notification-badge.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function NotificationBadge(props) {
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx("div", {
      className: text,
      children: props.children
    }), props.count && /*#__PURE__*/jsx("div", {
      className: count,
      children: props.count
    })]
  });
}

export { NotificationBadge };
//# sourceMappingURL=notification-badge.js.map
